import React from 'react';
import {SceneBridge,sceneSelection} from '../lib/scene.js';

export class ExerciseGuide extends React.Component{
  constructor(p){super(p);this.frame=React.createRef();this.dialog=React.createRef();this.state={details:false,sceneStatus:'',busy:false};}
  componentWillUnmount(){this.bridge?.dispose();}
  close=()=>{this.bridge?.dispose();this.bridge=null;if(this.dialog.current?.open)this.dialog.current.close();this.setState({sceneStatus:'',busy:false});}
  async showScene(){
    const {controller:c,state:s,equipmentId,branchId}=this.props;
    if(!equipmentId||this.state.busy)return;
    this.setState({busy:true,sceneStatus:'Cihaz eşleşmesi doğrulanıyor…'});
    try{
      const result=await c.api.call(`/api/g06/scene/equipment/${encodeURIComponent(equipmentId)}?branchId=${encodeURIComponent(branchId)}`);
      if(result.status!=='found'){this.setState({sceneStatus:'Bu fiziksel cihazın sahne eşleşmesi henüz doğrulanmadı.',busy:false});return;}
      const scene=sceneSelection(s.config,branchId);
      if(scene.kind!=='real-runtime'){this.setState({sceneStatus:'Bu şube için doğrulanmış gerçek sahne hazır değil.',busy:false});return;}
      this.dialog.current.showModal();
      this.bridge?.dispose();
      this.bridge=new SceneBridge(this.frame.current,{...scene,allowedOrigin:location.origin,onStatus:status=>this.setState({sceneStatus:status})});
      const wait=()=>new Promise((ok,no)=>{let n=0;const tick=()=>{if(this.bridge?.ready)return ok();if(++n>50)return no(new Error('Sahne hazırlanamadı.'));setTimeout(tick,100);};tick();});
      await wait();const focused=await this.bridge.focus(equipmentId);
      this.setState({sceneStatus:focused.result==='found'?'Doğrulanmış fiziksel cihaz sahnede gösteriliyor.':'Sahne bu cihazı bulamadı.',busy:false});
    }catch(e){this.setState({sceneStatus:e?.message||'Salon bağlantısı tamamlanamadı.',busy:false});}
  }
  render(){
    const {entry,equipmentId,branchId}=this.props,{details,sceneStatus,busy}=this.state;
    const media=entry?.animationUrl||entry?.imageUrl;
    return <div className="exercise-guide">
      <div className="row wrap">
        <button type="button" className="text-button" onClick={()=>this.setState({details:!details})}>{details?'Anlatımı kapat':'Nasıl yapılır?'}</button>
        {branchId==='mega'&&<button type="button" className="text-button" disabled={!equipmentId||busy} onClick={()=>this.showScene()}>{busy?'Doğrulanıyor…':'Cihazı salonda göster'}</button>}
      </div>
      {sceneStatus&&!this.dialog.current?.open&&<p className="small muted" role="status">{sceneStatus}</p>}
      {details&&<div className="exercise-help">
        {media&&(/\.mp4(?:$|\?)/i.test(media)?<video src={media} controls playsInline preload="none" aria-label={`${entry?.nameTr||entry?.name||'Hareket'} kaynak gösterimi`}/>:<img src={media} alt={`${entry?.nameTr||entry?.name||'Hareket'} kaynak gösterimi`} loading="lazy"/>)}
        {entry?.instructions?.length?<ol className="instructions">{entry.instructions.map((x,i)=><li key={i}>{x}</li>)}</ol>:<p className="muted small">Bu hareket için metin anlatımı bulunmuyor.</p>}
        <p className="small muted">Kaynak anlatım; kişisel program kararını ve fiziksel eğitmen yardımını değiştirmez.</p>
      </div>}
      <dialog ref={this.dialog} aria-label="Mega cihaz konumu" onCancel={e=>{e.preventDefault();this.close();}}>
        <div className="row between"><strong>Mega · cihazın konumu</strong><button type="button" onClick={this.close}>Antrenmana dön</button></div>
        <p role="status">{sceneStatus}</p><iframe ref={this.frame} title="Mega 3D salon turu" className="scene-frame" sandbox="allow-scripts allow-same-origin"/>
      </dialog>
    </div>;
  }
}
